import {Dialog} from '@jobseeker/lotus/components';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {Box, Button, Typography} from '@mui/material';
import {Select} from '@jobseeker/lotus/elements';
import {useState} from 'react';
import {Image} from '@jobseeker/lotus/components/Image';
import {Right} from '@jobseeker/lotus/assets/icons';

type SlotDetails = {
  slotId: string;
  calendarId: string;
  address: string;
  messageTelephonic: string;
  inviteStatus: number;
  slotType: string;
  recruiterId: number;
  slotDate: string;
  slotTime: string;
  status: number;
  jobInfo: {
    title: string;
    minExp: number;
    maxExp: number;
    locations: string;
    confidential: number;
  };
  recruiterInfo: {
    name: string;
    organization: string;
    designation: string;
    profileLink: string;
    imgUrl: string;
    companyId: number;
  };
  formattedDate: string;
  calendarLinks: {
    google: string;
    yahoo: string;
    outlook: string;
  };
};

type PropType = {
  slotDetails: SlotDetails | undefined;
  open: boolean;
};

const PostSlotConfirmationDialog = (props: PropType) => {
  const [menuOpen, setOpen] = useState<string | boolean>(false);

  if (!props.slotDetails) {
    return;
  }

  const {
    slotDetails: {
      slotType,
      address,
      messageTelephonic,
      formattedDate,
      calendarLinks: cLinks,
    },
    open,
  } = props;
  const calendarLinks = [cLinks.google, cLinks.yahoo, cLinks.outlook];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setMenuOpen = (value: any) => {
    if (value && value === menuOpen) {
      setMenuOpen(false);
    } else setOpen(value);
  };

  const handlePostSlotConfirmationDialogClose = () => {
    openUrl('/interviews', '_self');
  };

  return (
    <Dialog
      variant={VersionVariants.VERSION_THREE}
      open={open}
      title=""
      titleProps={{
        height: 40,
      }}
      onClose={handlePostSlotConfirmationDialogClose}
      sx={{
        '& .MuiPaper-root': {
          width: {xs: 350, md: 700},
          borderRadius: '8px',
          textAlign: 'center',
        },
        '& .MuiDialogContent-root': {
          px: 4.375,
          py: 5,
        },
        '& .MuiIconButton-root': {
          ':hover': {
            bgcolor: 'transparent',
          },
        },
      }}
    >
      <Image src={Right} alt="slot-confirmed" height={50} width={50} />
      <Typography fontSize={20} fontWeight={500} mt={1.25}>
        Confirmed
      </Typography>
      <Typography fontSize={18} fontWeight={200} mb={1.875}>
        Your interview has been scheduled
      </Typography>
      <Typography fontSize={15} mb={0.625}>
        Time: {formattedDate}
      </Typography>
      <Typography mb={0.625} maxWidth={1000}>
        Message / Address:{' '}
        {slotType === 'TELEPHONIC' ? messageTelephonic : address}
      </Typography>
      <Box>
        <Select
          name="add-to-calendar"
          maxWidth={200}
          menuOpen={menuOpen === 'add-to-calendar'}
          setMenuOpen={setMenuOpen}
          label="Add to your calendar&nbsp;"
          variant={VersionVariants.VERSION_TWO}
          onChange={e => {
            const index = (e?.target?.value as number) ?? 0;
            openUrl(calendarLinks[index], '_blank');
          }}
          options={[
            {
              label: 'Add Google',
              value: 0,
            },
            {
              label: 'Add Yahoo',
              value: 1,
            },
            {
              label: 'Add Outlook',
              value: 2,
            },
          ]}
          sx={{
            '& .MuiInputBase-input': {
              backgroundColor: 'transparent',
              border: '1px solid #E9630C !important',
              borderRadius: '4px !important',
              color: '#E9630C',
              fontSize: 14,
            },
            '& .MuiMenuItem-root>.MuiTypography-root': {
              menuItemFontSize: 14,
            },
            my: 2.5,
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                '& .MuiMenuItem-root': {
                  '&:hover': {
                    backgroundColor: 'rgb(239, 243, 250)',
                    color: 'white',
                  },
                },
              },
            },
          }}
        />
      </Box>
      <Button
        variant="contained"
        sx={{
          borderRadius: 0.625,
          fontSize: 16,
          fontWeight: 500,
          py: 1.5,
          width: 200,
          height: 48,
        }}
        onClick={() => {
          openUrl('/jobfeed', '_self');
        }}
      >
        View Jobfeed
      </Button>
    </Dialog>
  );
};

export default PostSlotConfirmationDialog;
